import { config } from '../../config';

export const platformType = config.REACT_APP_PLATFORM_TYPE;
